import * as actions from '../services'
import * as types from 'src/app/pages/auth/vuex/mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { t } from 'src/utils/form'

export const createAccount = (context, payload) => {
  var onlyNumber = /[\D]/g
  var user = {}
  user.seller = Object.assign({}, payload.seller)
  user.seller.address_attributes = Object.assign({}, user.seller.address_attributes)
  user.seller.contact_attributes = Object.assign({}, user.seller.contact_attributes)
  user.seller.cpf = user.seller.cpf.replace(onlyNumber, '')
  user.seller.address_attributes.postal_code = user.seller.address_attributes.postal_code.replace(onlyNumber, '')

  if (user.seller.kind === 'P') {
    delete user.seller.cnpj
  } else {
    user.seller.cnpj = user.seller.cnpj.replace(onlyNumber, '')
  }

  return actions.signUp(user)
  .then(function (response) {
    if (response && response.status === 200 || response.status === 201) {
      context.commit(addFlash, { message: t(context, 'application.login.account_created_with_success'), type: 'ls-alert-success' })
      context.commit(types.setUserToken, response.data.auth_token)
      var user = {
        id: response.data.user.id,
        name: response.data.user.seller.name,
        email: response.data.user.email,
        trade_name: response.data.user.seller.trade_name,
        created_at: response.data.user.seller.created_at
      }
      context.commit(types.setUser, user)
    }
    return response
  })
}

export const getAddress = (context, payload) => {
  var onlyNumber = /[\D]/g
  var postalCode = payload.replace(onlyNumber, '')

  return actions.getPostalCode(postalCode)
  .then(function (response) {
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/signup/vuex/actions.js